export default "__VITE_PUBLIC_ASSET__9bd5317d__"